"use client";

import { Input } from "@/components/ui/input";
import { setHolidayFilters, useHolidayFilter } from "@/feature/holiday/search/state/extract-holiday-filter-slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { HolidayAccordion } from "./holiday-accordion";

export function HolidayNameFilter() {
  const dispatch = useAppDispatch();
  const { selectedOption } = useAppSelector(useHolidayFilter);

  return (
    <HolidayAccordion value="holiday_name" label="Package Name">
      <Input
        value={selectedOption.query}
        onChange={(event) => {
          dispatch(setHolidayFilters({ query: event.target.value }));
        }}
        placeholder="Search package title"
      />
    </HolidayAccordion>
  );
}

